// extracted by mini-css-extract-plugin
module.exports = {"wrap":"image-module--wrap--diQQZ"};